"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = useGridDebug;

var _react = require("react");

function useGridDebug() {
  var _window;

  var isClient = typeof window !== 'undefined';
  var isDev = process.env.NODE_ENV == 'development';
  var tabulaConfig = isClient && isDev ? JSON.parse((_window = window) === null || _window === void 0 ? void 0 : _window.localStorage.getItem('tabula')) || {
    debug: false
  } : {};
  var setTabulaConfig = isClient && isDev ? function () {
    return window.localStorage.setItem('tabula', JSON.stringify(tabulaConfig));
  } : function () {
    return undefined;
  };

  function onKeyUp(event) {
    if (event.shiftKey == true && event.ctrlKey == true && (event.keyCode || event.which) == 68) {
      tabulaConfig.debug = !tabulaConfig.debug;
      document.body.classList.toggle('debug', tabulaConfig.debug);
      setTabulaConfig();
    }
  }

  (0, _react.useEffect)(function () {
    if (isDev && isClient) {
      document.body.classList.toggle('debug', tabulaConfig.debug);
      document.body.addEventListener('keyup', onKeyUp);
      return function () {
        return document.body.removeEventListener('keyup', onKeyUp);
      };
    }
  });
}